<template>
  <!-- Hide the default audio player -->
  <audio
    ref="player"
    style="display:none"
  >
    <source
      :src="url"
      type="audio/mpeg"
    >
  </audio>

    
  <button
    class="text-pink-500 focus:outline-hidden focus-visible:ring-pink-600 focus-visible:ring-offset-2 focus-visible:ring transition-all duration-300 ease-in-out
      py-4 px-8 text-lg flex gap-2 items-center justify-center border-2 shadow-xs rounded-full"
    :aria-label="(isPlaying ? 'Pause ' : 'Play ') + text"
    :class="(isPlaying ? 'bg-pink-500 text-white border-pink-500' : 'bg-white text-pink-500 border-pink-500')"
    @click="toggleAudio"
  >
    <span
      class="font-semibold mr-2"
      v-text="text"
    />
    <span class="w-8 h-8 shrink-0">
      <Transition
        name="fade"
        mode="out-in"
        enter-from-class="opacity-0"
        enter-active-class="transition-opacity duration-500"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-500"
      >
        <SvgIcon
          v-if="isPlaying"
          aria-hidden="true"
          icon-name="pause-circle"
          class="w-8 h-8 shrink-0"
        />
        <SvgIcon
          v-else
          aria-hidden="true"
          icon-name="play-circle"
          class="w-8 h-8 shrink-0"
        />
      </Transition>
    </span>
  </button>
</template>

<script lang="ts">
export default { name: 'AudioPlayer' }
</script>

<script setup lang="ts">
import { ref, watch } from 'vue'

defineProps<{
  url: string,
  text: string,
}>()

const player = ref<HTMLAudioElement>()
let isPlaying = ref(false)
let listenerActive = ref(false)


watch(isPlaying, () => {
  if (!listenerActive.value) {
    listenerActive.value = true
    player.value?.addEventListener('timeupdate', playbackListener)
  }
})

const playbackListener = (e) => {
  player.value?.addEventListener('ended', endListener)
  player.value?.addEventListener('pause', pauseListener)
}

const pauseListener = () => {
  isPlaying.value = false
  listenerActive.value = false
  cleanupListeners()
}

const endListener = () => {
  isPlaying.value = false
  listenerActive.value = false
  cleanupListeners()
}

const cleanupListeners = () => {
  player.value?.removeEventListener('timeupdate', playbackListener)
  player.value?.removeEventListener('ended', endListener)
  player.value?.removeEventListener('pause', pauseListener)
}

const toggleAudio = () => {
  if (player.value?.paused) {
    player.value?.play()
    isPlaying.value = true
  } else {
    player.value?.pause()
    isPlaying.value = false
  }
}
</script>
